<div class="m-3">
  <div class="card">
    <div class="card-header">
      <div title class="header-custom" (click)="onToggleExpand()">
        <span class="custom-title">{{headerTitle}}</span>
        <span class="ml-2">
          <span class="pw-collapse collapse-expand" *ngIf="!expand"></span>
          <span class="pw-expand collapse-expand" *ngIf="expand"></span>
        </span>
      </div>
    </div>
    <div class="card-body" *ngIf="expand">
      <ng-content></ng-content>
    </div>
  </div>
</div>
